/**
 * mcycle step finish module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/20
 */
import './index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FinishRow from './finishRow';
import CircleTick from '../../../svgs/circleTick';

class Finish extends Component {
  constructor(props) {
    super(props);
    const { orderInfo } = this.props;
    if (!orderInfo.orderId) {
      window.location.replace('//mcycle.meizu.com/');
    }
  }

  INFO = {
    TITLE: `您的回购单提交成功！请在${this.props.orderInfo.supplierId === 1 ? 10 : 7}天内快递邮寄！`,
    ITEM: [{
      title: '回收方式',
      message: '快递邮寄'
    }, {
      title: '寄送地址',
      func: orderInfo => orderInfo.supplierAddressInfo && orderInfo.supplierAddressInfo.address
    }, {
      title: '收件人',
      func: orderInfo => orderInfo.supplierAddressInfo && `${orderInfo.supplierAddressInfo.contactName}  ${orderInfo.supplierAddressInfo.contactPhone}`
    }, {
      title: '快递邮费',
      message: '请选择顺丰快递货到付款（顺丰热线95338）'
    }],
    TIP: '寄出物品后，请填写物流单号。'
  }

  render() {
    const { orderInfo } = this.props;

    return (
      <div className="mcycle-step-finish">
        <CircleTick />
        <div className="mcycle-step-finish-info">
          <div className="mcycle-step-finish-title">{this.INFO.TITLE}</div>
          <ul className="mcycle-step-finish-info-list">
            {this.INFO.ITEM.map((item, index) =>
              <FinishRow title={item.title} message={item.message ? item.message : item.func(orderInfo) } />
            )}
          </ul>
          <div className="mcycle-step-info-tip">
            {this.INFO.TIP}
            <a href={`http://mcycle.meizu.com/page/order/detail/${orderInfo.orderId}`} className="mcycle-protocol-link">查询回购单详情</a>
          </div>
        </div>
        <div className="mcycle-step-finish-price">
          回收预估价 <p>￥{orderInfo.inquiryPrice}</p>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    orderInfo: state.step.orderInfo
  })
)(Finish)



// WEBPACK FOOTER //
// ./src/components/step3/finish/index.js